import { cartCounterFeature } from './cart-counter.reducers';

const { selectQuantity, selectGetQuantityAction } = cartCounterFeature;

export const CartCounterSelectors = { selectQuantity, selectGetQuantityAction };
